import { Tooltip as NativeTooltip } from "@/components/ui/tooltip";
import { SPACING } from "@/generic/config";
import { ReactNode } from "react";
import Text from "./Text";
import { Box } from "@chakra-ui/react";

const Tooltip = ({ tooltip, children }: { tooltip: string | ReactNode, children: ReactNode }) => {

    const content = typeof tooltip === "string" ? <Text variant="subtitle">{tooltip}</Text> : tooltip;
    return (
        <NativeTooltip openDelay={50} closeDelay={0} showArrow content={content} positioning={{ placement: "top", offset: { mainAxis: SPACING / 2 } }}>
            <Box>
                {children}
            </Box>
        </NativeTooltip>
    );
};

export default Tooltip;